// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.


const clientLocale: string | undefined | null = (navigator.languages && navigator.languages.length)
  ? navigator.languages[0]
  : navigator.language

const defaultCountry: string | undefined = (!!clientLocale)
  ? ((new Intl.Locale(clientLocale)).region || "NL")
  : "NL"


export {defaultCountry}